<template>
  <nav class="breadcrumbs">
    <ul class="flex">
      <li
        class="text-xs font-semibold lg:text-base inline cursor-pointer"
        v-for="(crumb, index) in crumbs"
        :key="index"
      >
        <router-link
          class="text-xs font-semibold lg:text-base cursor-pointer"
          :to="{
            name: crumb.name,
            query:
              !routeNamesToFilter.includes(crumb.name) &&
              !this.$route.query.orderId
                ? { id: this.$route.query.id }
                : !routeNamesToFilter.includes(crumb.name) &&
                  this.$route.query.orderId
                ? { OrderId: this.$route.query.orderId }
                : null,
          }"
          >{{ crumb.name }}</router-link
        >
        <span
          v-if="index < crumbs.length - 1"
          class="mr-1 text-green-400 text-xs font-bold align-middle"
        >
          ></span
        >
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ["crumbs", "routeNamesToFilter"],
};
</script>

<style scoped></style>
